export class InvertBooleanValueConverter {
    toView(value): boolean {
        return !value;
    }
}